import '@fontsource/roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { QueryParamProvider } from 'use-query-params';
import { globalHistory } from "@reach/router"


import { Provider } from 'react-redux';
import store from './store';

import App from './App';
import theme from './theme';
import { DialogProvider } from './components/DialogProvider';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <QueryParamProvider reachHistory={globalHistory}>
          <DialogProvider>
            <CssBaseline />
            <App />
          </DialogProvider>
        </QueryParamProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
